const initialState: Redux.Experiments = {
	assignments: {},
	configurations: {},
	gatekeeper: {},
};

export default initialState;
